import React from "react";
import { Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";



function InDevelopment() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const back = () => {
    navigate("/");
  };
  return (
    <Container className="text-center mt-5">
      <Row>
        <h1>This language is currently under development.</h1>
        <h3>We are working hard to bring it to you soon!</h3>
      </Row>
      <div class="make-center">
      <button  
            class="back-btn" onClick={back}>Go back</button>
      </div>
      <footer>
        <p>Vocaps ©{currentYear}.</p>
      </footer>
    </Container>

  );
}

export default InDevelopment;
